import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyBcpbjeHHkRzdNPFNmL2r9k-yDyVKind4o",
  authDomain: "bb-beaute.firebaseapp.com",
  databaseURL: "https://bb-beaute-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "bb-beaute",
  storageBucket: "bb-beaute.firebasestorage.app",
  messagingSenderId: "5556185217",
  appId: "1:5556185217:web:09b595534b62e66fa14580"
};

const app = initializeApp(firebaseConfig);
const database = getDatabase(app);
const storage = getStorage(app);

console.log("Firebase DB: Connected");

export { database, storage };